import React from 'react';
import PropTypes from 'prop-types';
import { GetRegion } from 'constants.js';
import LabelClaro from './LabelClaro';

class CheckboxClaro extends React.Component {
  render() {
    let finalTerms = null;
    const linkUrl = '/terminos_y_condiciones';
    if (
      !this.props.terminosLink ||
      this.props.terminosLink == '' ||
      this.props.terminosLink == '#'
    ) {
      finalTerms = (
        <a>
          {' '}
          {this.props.terminos1} {this.props.terminos2} {this.props.terminos3}
        </a>
      );
    } else {
      finalTerms = (
        <a href={linkUrl} target="_blank">
          {' '}
          {this.props.terminos1} {this.props.terminos2} {this.props.terminos3}
        </a>
      );
    }
    return (
      <div className="checkbox-inline padding-top-1">
        <label>
          <input
            type="checkbox"
            id={this.props.idElement}
            name={this.props.idElement}
            onChange={this.props.onChange}
          />

          <LabelClaro
            htmlFor={this.props.idElement}
            labelText={finalTerms}
            labelTip={this.props.labelTip}
          />
          <span className="help-block error-wrapper error-invalid">
            {this.props.error}
          </span>
        </label>
      </div>
    );
  }
}

CheckboxClaro.defaultProps = {
  terminosLink: '#',
};

CheckboxClaro.propTypes = {
  idElement: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelTip: PropTypes.string,
  error: PropTypes.string,
};

export default CheckboxClaro;
